module.exports = __webpack_public_path__ + "static/media/svm.19420630.jpg";